<template>
  <v-line :config="{points, stroke: color, strokeWidth: width}" />
</template>

<script>
export default {
  name: 'DrawLine',
  props: { 
    points: { // format: [X1, Y1, X2, Y2, ... Xn, Yn]
      type: Array,
      required: true
    },
    color: {
      type: String,
      default: 'black'
    },
    width: {
      validator (value) {return !isNaN(value)},
      default: 3
    }
  },
  data () {
    return {}
  }
}
</script>